import styled from "styled-components";
import { DonateButton } from "../../../views/FundraisingDetails/index.styles";

export const StatsSection = styled.aside`
  flex: 1;
  background: white;
  margin: 1.5rem;
  padding: 1.5rem;
  border-radius: 8px;
`;

export const StatsHeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AmountRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin: 0.25rem 0 1rem;
`;

export const BigAmount = styled.span`
  font-size: 2rem;
  font-weight: 700;
  color: #fe2f67;
`;

export const GoalText = styled.span`
  font: 10px;
  font-size: 0.65rem;
  color: #606770;
`;

export const ProgressBarBackground = styled.div`
  background: #e0e0e0;
  border-radius: 8px;
  width: 100%;
  height: 10px;
  margin: 0.5rem 0;
`;

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;
  margin: 1rem 0;
`;

export const KpiBox = styled.div`
  background: #f5f5f5;
  padding: 0.75rem 1rem;
  text-align: center;
  border-radius: 4px;
`;

export const KpiValue = styled.p`
  font: 700 22px/1;
  font-weight: 700;
  margin: 0;
`;

export const KpiLabel = styled.p`
  font: 400 12px/1;
  margin: 0;
  color: #606770;
`;

export const DateBox = styled.div`
  background: #f5f5f5;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1rem;
  justify-content: center;
  font: 600 16px/1;
  margin-bottom: 1rem;
  font-weight: 600;
`;

export const DonateButtonPink = styled(DonateButton)`
  background: #fe2f67;
  &:hover {
    background: #e8245a;
  }
`;

export const Hr = styled.hr`
  border: none;
  border-top: 1px solid #d9d9d9;
  margin: 1.25rem 0 0.75rem;
`;

interface ProgressBarFillProps {
    percent: number;
  }
  export const ProgressBarFill = styled.div<ProgressBarFillProps>`
    background: #fe2f67;
    height: 100%;
    width: ${(props) => props.percent}%;
    border-radius: 8px;
  `;